import { Camera } from 'domain/camera'
import { CameraHealthStatus } from 'features/cameras/types/camera-health.types'
import { CameraMapStatusInfo, getCameraMapStatus } from './camera-map-status'

export interface MappableCamera {
  camera: Camera
  latitude: number
  longitude: number
  statusInfo: CameraMapStatusInfo
}

const hasCoordinates = (
  camera: Camera
): camera is Camera & { latitude: number; longitude: number } =>
  typeof camera.latitude === 'number' &&
  typeof camera.longitude === 'number' &&
  !Number.isNaN(camera.latitude) &&
  !Number.isNaN(camera.longitude)

/**
 * Junta a lista de câmeras (endereço/lat/long) com o snapshot de saúde
 * (StreamHealthMonitor) por cameraId, e descarta as que não têm
 * coordenadas cadastradas — não têm onde aparecer no mapa.
 */
export const buildMappableCameras = (
  cameras: Camera[],
  health: CameraHealthStatus[]
): MappableCamera[] => {
  const healthByCameraId = new Map(health.map((h) => [h.cameraId, h]))

  return cameras.filter(hasCoordinates).map((camera) => ({
    camera,
    latitude: camera.latitude,
    longitude: camera.longitude,
    statusInfo: getCameraMapStatus(camera, healthByCameraId.get(camera.id)),
  }))
}
